<template>
  <div class="translate-wrapper" v-if="translateContent || translateType">
    <div ref="msgTxt"  v-if="processedText" v-html="processedText"></div>
    <div class="translate-bottom">{{ translateType }}<div class="translate-icon" @click="showSetLangPanel"></div></div>
  </div>
</template>

<script>
import Utils from '@/utils/string';
import b2cTextMsgTranslate from '@/utils/translateMsg';
import globalWin from '@/utils/globalWin';
export default {
  props: {
    data: '',
  },
  data() {
    return {
      translateContent: '',
      translateType: '',
    };
  },
  computed: {
    processedText() {
      // 过滤html，仅保留 a；
      let text = Utils.filterHTML(this.translateContent);
      text = Utils.emojiEscape(text);
      // 当文本中不包括 a连接时，才进行转发
      return text;
    },
  },
  watch: {
    data: {
      immediate: true,
      handler() {
        this.translate();
      },
    },
  },

  methods: {
    /**
     * 打开切换语言弹窗
     */
    showSetLangPanel() {
      globalWin.switchSetLangPanel(true);
    },

    async translate() {
      const translateConf = {
        translateLang: this.$i18n.locale,
        kfuin: globalWin.kfuin,
      };
      const tranlateMsgRes = await b2cTextMsgTranslate(translateConf, this.data).catch(() => {
        this.translateContent = '';
        this.translateType = '';
      // this.processedText = '';
      });
      if (!tranlateMsgRes) {
        this.translateContent = '';
        this.translateType = '';
        // this.processedText = '';
        return;
      }
      switch (tranlateMsgRes.type) {
        case 'success': {
          this.translateType = this.$t('common_tencent_translator');
          break;
        };
        case 'fail': {
          this.translateType = this.$t('common_tencent_translator_fail');
          break;
        };
        case 'only': {
          this.translateType = this.$t('common_tencent_translator_only');
          break;
        };
        default: {
          this.translateType = '';
        }
      };
      this.translateContent = tranlateMsgRes.targetText;
    },
  },
};
</script>

<style lang="less" scoped>
@import './style.less';
.translate-wrapper {
    margin-top: 8px;
    border-top: 1px solid #ebedf2;

    .translate-content {
        padding-top: 8px;
        line-height: 18px;
        white-space: pre-wrap;
        word-wrap: break-word;
        word-break: break-word;
    }

    .translate-bottom {
        position: relative;
        font-size: 12px;
        line-height: 14px;
        color: #b8b9bc;
        margin-top: 6px;
        min-width: 190px;
        padding-right: 15px;
    }

    .translate-icon {
        position: absolute;
        right: -5px;
        bottom: 0;
        width: 14px;
        height: 14px;
        background: url(@bg);
    }
}
</style>
